import React, { useState } from 'react';
import './SocialLinksEditor.css';

interface SocialLinksEditorProps {
  socialLinks: { facebook: string; twitter: string; instagram: string };
  handleSocialLinkChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
}

const SocialLinksEditor: React.FC<SocialLinksEditorProps> = ({
  socialLinks,
  handleSocialLinkChange,
  handleSaveChanges,
  handleCancelEdit
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="social-links-editor">
      <div className="social-links-item">
        <h3 onClick={toggleAccordion} className="accordion-toggle">
          Cambiar Enlaces de Redes Sociales
        </h3>
        {isOpen && (
          <div className="social-links-content">
            <div>
              <label>Facebook</label>
              <input
                type="text"
                name="facebook"
                value={socialLinks.facebook}
                onChange={handleSocialLinkChange}
              />
            </div>
            <div>
              <label>Twitter</label>
              <input
                type="text"
                name="twitter"
                value={socialLinks.twitter}
                onChange={handleSocialLinkChange}
              />
            </div>
            <div>
              <label>Instagram</label>
              <input
                type="text"
                name="instagram"
                value={socialLinks.instagram}
                onChange={handleSocialLinkChange}
              />
            </div>

            <div className="social-links-buttons">
              <button onClick={handleSaveChanges}>Guardar Cambios</button>
              <button className="cancel-button" onClick={handleCancelEdit}>Cancelar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SocialLinksEditor;
